import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { decimalToTwoDecimals, DateTimeExtensions_toDate, Locale$reflection } from "../../Utils.js";
import { record_type, bool_type, option_type, list_type, lambda_type, class_type, union_type, string_type, unit_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { CreateDirectInvoiceDTO, InvoiceFeeDTO, CreateDirectInvoiceDTO$reflection, DirectInvoiceInfo$reflection } from "../../Api/DirectInvoice.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { InvoiceFee, InvoiceFee$reflection, CampaignCode$reflection } from "./Model.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { LoadState$2, getTranslationFrom } from "../../Global.js";
import * as react from "react";
import { exists, length, mapIndexed, filter, singleton as singleton_1, append, sumBy, map as map_1, empty } from "../../fable_modules/fable-library.3.7.20/List.js";
import { compare, op_Addition, equals, fromParts } from "../../fable_modules/fable-library.3.7.20/Decimal.js";
import Decimal from "../../fable_modules/fable-library.3.7.20/Decimal.js";
import { map, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { MessageKind, customMessage, warning, error, info } from "../../Components/Message/Message.js";
import { HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { SelectOption, ValueProp, SelectOption_get_getDefault, selectOption, CheckboxInput, CheckboxInput_get_getDefault, inputCheckbox } from "../../Components/FormFields/FormFields.js";
import { Browser_Types_Event__Event_get_Value, Browser_Types_Event__Event_get_Checked } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { empty as empty_1, singleton as singleton_2, append as append_1, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { PageinationProps$1, Pagination } from "../../Components/Pagination/Pagination.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { uncurry, int32ToString } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { SwitchProps, SwitchProps_get_GetDefault, render as render_1 } from "../../Components/Switch/Switch.js";
import { unEscape } from "../../Utilities/String.js";
import { render as render_2 } from "../../Components/Modals/Standard.js";
import { ModalSize } from "../../Components/Modal/Modal.js";

export class DirectInvoiceModalProps extends Record {
    constructor(Locale, LoadDirectInvoiceInfo, LoadCampignCodes, CampaignCode, DirectDebitDistributed, InvoiceFees, EnableTerminationProcess, CreateDirectInvoice, CloseModalFn) {
        super();
        this.Locale = Locale;
        this.LoadDirectInvoiceInfo = LoadDirectInvoiceInfo;
        this.LoadCampignCodes = LoadCampignCodes;
        this.CampaignCode = CampaignCode;
        this.DirectDebitDistributed = DirectDebitDistributed;
        this.InvoiceFees = InvoiceFees;
        this.EnableTerminationProcess = EnableTerminationProcess;
        this.CreateDirectInvoice = CreateDirectInvoice;
        this.CloseModalFn = CloseModalFn;
    }
}

export function DirectInvoiceModalProps$reflection() {
    return record_type("Containers.Invoices.DirectInvoice.DirectInvoiceModalProps", [], DirectInvoiceModalProps, () => [["Locale", Locale$reflection()], ["LoadDirectInvoiceInfo", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [DirectInvoiceInfo$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", DirectInvoiceInfo$reflection()]], [["ErrorValue", string_type]]])]))], ["LoadCampignCodes", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(CampaignCode$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(CampaignCode$reflection())]], [["ErrorValue", string_type]]])]))], ["CampaignCode", option_type(string_type)], ["DirectDebitDistributed", bool_type], ["InvoiceFees", list_type(InvoiceFee$reflection())], ["EnableTerminationProcess", bool_type], ["CreateDirectInvoice", lambda_type(CreateDirectInvoiceDTO$reflection(), unit_type)], ["CloseModalFn", lambda_type(unit_type, unit_type)]]);
}

export const renderDirectInvoiceModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let inputRecord_1, inputRecord_2, OptionValues, LabelText_2, children_12, children_14, inputRecord_3, children_18, children_20, arg_12, children_24, children_26, children_30, inputRecord_4, arg_15, arg_14, arg_13;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const campaignCodesState = react.useState(empty());
    const noInvoiceFeeState = react.useState(true);
    const totalAmountInclVatState = react.useState(fromParts(0, 0, 0, false, 0));
    const directDebitDistributedState = react.useState(false);
    const allFeesAreInvoicedState = react.useState(false);
    const feeState = react.useState(empty());
    const campignCodesLoadState = react.useState(new LoadState$2(0));
    const directInvoiceLoadState = react.useState(new LoadState$2(0));
    let campaignCodeState;
    const arg_4 = defaultArg(map((value) => value, props.CampaignCode), "");
    campaignCodeState = react.useState(arg_4);
    react.useEffect(() => {
        directInvoiceLoadState[1](new LoadState$2(1));
        startImmediate(singleton.Delay(() => singleton.Bind(props.LoadDirectInvoiceInfo(), (_arg) => {
            const result = _arg;
            let arg;
            if (result.tag === 1) {
                arg = (new LoadState$2(3, result.fields[0]));
            }
            else {
                const directInvoiceInfo = result.fields[0];
                feeState[1](map_1((f_2) => (new InvoiceFee(f_2.FeeNr, f_2.Description, f_2.AmountExclVat, f_2.AmountInclVat, f_2.Period, f_2.PeriodFrom, f_2.PeriodTo, f_2.ContractNr, true)), directInvoiceInfo.Fees));
                noInvoiceFeeState[1](equals(directInvoiceInfo.InvoiceFeeInclVat, fromParts(0, 0, 0, false, 0)));
                const totalAmountInclVat_1 = sumBy((f_3) => f_3.AmountInclVat, directInvoiceInfo.Fees, {
                    GetZero: () => (new Decimal(0)),
                    Add: op_Addition,
                });
                const invoiceFeeInclVat_2 = (noInvoiceFeeState[0]) ? fromParts(0, 0, 0, false, 0) : directInvoiceInfo.InvoiceFeeInclVat;
                allFeesAreInvoicedState[1](true);
                totalAmountInclVatState[1](op_Addition(totalAmountInclVat_1, invoiceFeeInclVat_2));
                arg = (new LoadState$2(2, directInvoiceInfo));
            }
            directInvoiceLoadState[1](arg);
            return singleton.Zero();
        })));
    }, []);
    react.useEffect(() => {
        campignCodesLoadState[1](new LoadState$2(1));
        startImmediate(singleton.Delay(() => singleton.Bind(props.LoadCampignCodes(), (_arg_1) => {
            const result_1 = _arg_1;
            let arg_2;
            if (result_1.tag === 1) {
                arg_2 = (new LoadState$2(3, result_1.fields[0]));
            }
            else {
                const campaignCodes = result_1.fields[0];
                let campaignCodesItems;
                const list_7 = map_1((campaignCode) => [campaignCode.CampaignCode, campaignCode.Description], campaignCodes);
                campaignCodesItems = append(singleton_1(["", getTranslation("Billing.DirectInvoice.CampignCodeStandard")]), list_7);
                campaignCodesState[1](campaignCodesItems);
                arg_2 = (new LoadState$2(2, campaignCodes));
            }
            campignCodesLoadState[1](arg_2);
            return singleton.Zero();
        })));
    }, []);
    let bodyHtml;
    const matchValue_3 = directInvoiceLoadState[0];
    switch (matchValue_3.tag) {
        case 0: {
            const children_44 = [info(getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.WaitingToLoadSubscription").split(""))];
            bodyHtml = react.createElement("div", {
                className: "mt-2",
                ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.WaitingToLoadSubscription",
            }, ...children_44);
            break;
        }
        case 1: {
            const children_46 = [info(getTranslation("CustomerContract.Invoicee.Subscriptions.Overview.WaitingToLoadSubscription").split(""))];
            bodyHtml = react.createElement("div", {
                className: "mt-2",
                ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Overview.WaitingToLoadSubscription",
            }, ...children_46);
            break;
        }
        case 3: {
            const children_48 = [error(matchValue_3.fields[0].split(""))];
            bodyHtml = react.createElement("div", {
                className: "mt-2",
            }, ...children_48);
            break;
        }
        default: {
            const directInvoiceInfo_1 = matchValue_3.fields[0];
            let invoiceAllFeesHtml;
            const props_3 = [new HTMLAttr(65, "direct-invoice__all-fees"), new HTMLAttr(158, getTranslation("Billing.DirectInvoice.AllFeesAreInvoicedInfo"))];
            const children_2 = [inputCheckbox((inputRecord_1 = CheckboxInput_get_getDefault(), new CheckboxInput(inputRecord_1.Disabled, getTranslation("Billing.DirectInvoice.AllFeesAreInvoiced"), (e_1) => {
                const tupledArg = [Browser_Types_Event__Event_get_Checked(e_1), directInvoiceInfo_1.InvoiceFeeInclVat];
                const isChecked = tupledArg[0];
                const updatedInvoiceFees = map_1((invoiceFee) => (new InvoiceFee(invoiceFee.FeeNr, invoiceFee.Description, invoiceFee.AmountExclVat, invoiceFee.AmountInclVat, invoiceFee.Period, invoiceFee.PeriodFrom, invoiceFee.PeriodTo, invoiceFee.ContractNr, isChecked)), feeState[0]);
                feeState[1](updatedInvoiceFees);
                const totalAmountInclVat = sumBy((f_1) => f_1.AmountInclVat, filter((f) => (f.IsChecked === true), updatedInvoiceFees), {
                    GetZero: () => (new Decimal(0)),
                    Add: op_Addition,
                });
                const invoiceFeeInclVat_1 = (noInvoiceFeeState[0]) ? fromParts(0, 0, 0, false, 0) : tupledArg[1];
                allFeesAreInvoicedState[1](isChecked);
                totalAmountInclVatState[1](op_Addition(totalAmountInclVat, invoiceFeeInclVat_1));
            }, allFeesAreInvoicedState[0], "direct-invoice-all-fees", inputRecord_1.HTMLProps)))];
            invoiceAllFeesHtml = react.createElement("div", keyValueList(props_3, 1), ...children_2);
            let invoiceFeeSelectionHtml;
            const children_8 = toList(delay(() => {
                let props_5, children_4;
                return append_1(singleton_2((props_5 = [new HTMLAttr(65, "mr-4"), ["data-translation", "Billing.DirectInvoice.SelectFeesToInvoicedInfo"], new HTMLAttr(158, getTranslation("Billing.DirectInvoice.SelectFeesToInvoicedInfo"))], (children_4 = [getTranslation("Billing.DirectInvoice.SelectFeesToInvoiced")], react.createElement("span", keyValueList(props_5, 1), ...children_4)))), delay(() => singleton_2(Pagination()(new PageinationProps$1((items) => {
                    const children_6 = mapIndexed((index, invoiceFee_2) => {
                        let inputRecord, matchValue_4, arg_6, arg_5;
                        const children = [inputCheckbox((inputRecord = CheckboxInput_get_getDefault(), new CheckboxInput(inputRecord.Disabled, (matchValue_4 = invoiceFee_2.ContractNr, (matchValue_4 == null) ? toText(printf("%s %.2f kr"))(invoiceFee_2.Description)(invoiceFee_2.AmountInclVat) : ((arg_6 = int32ToString(matchValue_4), (arg_5 = getTranslation("Common.SubscriptionNr"), toText(printf("%s : %s - %s %.2f kr"))(arg_5)(arg_6)(invoiceFee_2.Description)(invoiceFee_2.AmountInclVat))))), (e) => {
                            const tupledArg_1 = [new InvoiceFee(invoiceFee_2.FeeNr, invoiceFee_2.Description, invoiceFee_2.AmountExclVat, invoiceFee_2.AmountInclVat, invoiceFee_2.Period, invoiceFee_2.PeriodFrom, invoiceFee_2.PeriodTo, invoiceFee_2.ContractNr, Browser_Types_Event__Event_get_Checked(e)), directInvoiceInfo_1.InvoiceFeeInclVat];
                            const invoiceFee$0027 = tupledArg_1[0];
                            const updatedInvoiceFees_1 = map_1((invoiceFee_1) => {
                                if (invoiceFee$0027.FeeNr === invoiceFee_1.FeeNr) {
                                    return invoiceFee$0027;
                                }
                                else {
                                    return invoiceFee_1;
                                }
                            }, feeState[0]);
                            feeState[1](updatedInvoiceFees_1);
                            const totalAmountInclVat_2 = sumBy((f_5) => f_5.AmountInclVat, filter((f_4) => (f_4.IsChecked === true), updatedInvoiceFees_1), {
                                GetZero: () => (new Decimal(0)),
                                Add: op_Addition,
                            });
                            const invoiceFeeInclVat_4 = (noInvoiceFeeState[0]) ? fromParts(0, 0, 0, false, 0) : tupledArg_1[1];
                            totalAmountInclVatState[1](op_Addition(totalAmountInclVat_2, invoiceFeeInclVat_4));
                        }, invoiceFee_2.IsChecked, toText(printf("direct_invoice_fee-%i"))(index), inputRecord.HTMLProps)))];
                        return react.createElement("div", {
                            className: "container__item",
                        }, ...children);
                    }, items);
                    return react.createElement("div", {
                        className: "container__list",
                        ["data-regression"]: "container__list",
                    }, ...children_6);
                }, feeState[0], 5, 0)))));
            }));
            invoiceFeeSelectionHtml = react.createElement("div", {
                className: "direct-invoice__container",
            }, ...children_8);
            let campaignCodeHtml;
            const children_10 = [selectOption((inputRecord_2 = SelectOption_get_getDefault(), (OptionValues = (campaignCodesState[0]), (LabelText_2 = getTranslation("Billing.DirectInvoice.CampaignCode"), new SelectOption(new ValueProp(0, campaignCodeState[0], (e_2) => {
                campaignCodeState[1](Browser_Types_Event__Event_get_Value(e_2));
            }), "direct-invoice-invoice-campaign-code", OptionValues, inputRecord_2.Classes, LabelText_2, inputRecord_2.Disabled, inputRecord_2.HTMLProps)))))];
            campaignCodeHtml = react.createElement("div", {
                className: "d-flex mt-2 mb-2",
            }, ...children_10);
            let directDebitDistributedHtml;
            const children_16 = [(children_12 = [getTranslation("Billing.DirectInvoice.DirectDebitDistributed")], react.createElement("span", {
                ["data-translation"]: "Billing.DirectInvoice.DirectDebitDistributed",
            }, ...children_12)), (children_14 = [render_1((inputRecord_3 = SwitchProps_get_GetDefault(), new SwitchProps("direct-invoice-invoice-direct-debit-distributed", directDebitDistributedState[0], (e_3) => {
                directDebitDistributedState[1](Browser_Types_Event__Event_get_Checked(e_3));
            }, inputRecord_3.IsDisabled)))], react.createElement("div", {
                className: "pl-3",
            }, ...children_14))];
            directDebitDistributedHtml = react.createElement("div", {
                className: "d-flex align-items-center",
            }, ...children_16);
            let invoiceDateHtml;
            const children_22 = [(children_18 = [getTranslation("Billing.DirectInvoice.InvoiceDate")], react.createElement("span", {
                className: "mr-4",
                ["data-translation"]: "Billing.DirectInvoice.InvoiceDate",
            }, ...children_18)), (children_20 = [(arg_12 = DateTimeExtensions_toDate(props.Locale.ILocale, directInvoiceInfo_1.InvoiceDate), toText(printf("%s"))(arg_12))], react.createElement("span", {
                className: "font-weight-bold",
            }, ...children_20))];
            invoiceDateHtml = react.createElement("div", {
                className: "d-flex",
            }, ...children_22);
            let invoiceAmountHtml;
            const children_28 = [(children_24 = [getTranslation("Billing.DirectInvoice.InvoiceAmount")], react.createElement("span", {
                className: "mr-4",
                ["data-translation"]: "Billing.DirectInvoice.InvoiceAmount",
            }, ...children_24)), (children_26 = [decimalToTwoDecimals(totalAmountInclVatState[0])], react.createElement("span", {
                className: "font-weight-bold",
            }, ...children_26))];
            invoiceAmountHtml = react.createElement("div", {
                className: "d-flex",
            }, ...children_28);
            let invoiceFeeHtml;
            const children_32 = [(children_30 = [getTranslation("Billing.DirectInvoice.InvoiceFee")], react.createElement("span", {
                className: "mr-4",
                ["data-translation"]: "Billing.DirectInvoice.InvoiceFee",
            }, ...children_30)), render_1((inputRecord_4 = SwitchProps_get_GetDefault(), new SwitchProps("direct-invoice-invoice-fee", !(noInvoiceFeeState[0]), (e_4) => {
                const tupledArg_2 = [!Browser_Types_Event__Event_get_Checked(e_4), directInvoiceInfo_1.InvoiceFeeInclVat];
                const includeInvoiceFee = tupledArg_2[0];
                const totalAmountInclVat_3 = sumBy((f_7) => f_7.AmountInclVat, filter((f_6) => (f_6.IsChecked === true), feeState[0]), {
                    GetZero: () => (new Decimal(0)),
                    Add: op_Addition,
                });
                const invoiceFeeInclVat_6 = includeInvoiceFee ? fromParts(0, 0, 0, false, 0) : tupledArg_2[1];
                noInvoiceFeeState[1](includeInvoiceFee);
                totalAmountInclVatState[1](op_Addition(totalAmountInclVat_3, invoiceFeeInclVat_6));
            }, inputRecord_4.IsDisabled)))];
            invoiceFeeHtml = react.createElement("div", {
                className: "d-flex align-items-center",
            }, ...children_32);
            let warningMessage;
            const children_34 = [warning(((arg_15 = getTranslation("Billing.DirectInvoice.MinimumAmountWarning2"), (arg_14 = decimalToTwoDecimals(directInvoiceInfo_1.MinimumInvoiceAmountInclVat), (arg_13 = getTranslation("Billing.DirectInvoice.MinimumAmountWarning1"), toText(printf("%s, %s%s"))(arg_13)(arg_14)(arg_15))))).split(""))];
            warningMessage = react.createElement("div", {
                className: "mt-3",
            }, ...children_34);
            let infoMessageHtml;
            const message = unEscape(getTranslation("Billing.DirectInvoice.InfoText"));
            infoMessageHtml = customMessage(react.createElement("div", {
                className: "invoices__direct-invoice-info",
            }, message), new MessageKind(0));
            const children_42 = toList(delay(() => append_1(singleton_2(react.createElement("div", {
                className: "mb-3",
            }, infoMessageHtml)), delay(() => append_1(singleton_2(react.createElement("div", {
                className: "mb-1",
            }, invoiceAllFeesHtml)), delay(() => append_1((!(allFeesAreInvoicedState[0])) ? singleton_2(invoiceFeeSelectionHtml) : empty_1(), delay(() => append_1((length(campaignCodesState[0]) > 1) ? singleton_2(campaignCodeHtml) : empty_1(), delay(() => append_1(directInvoiceInfo_1.CanDistributed ? singleton_2(directDebitDistributedHtml) : empty_1(), delay(() => append_1(singleton_2(invoiceDateHtml), delay(() => append_1(singleton_2(invoiceAmountHtml), delay(() => append_1((!equals(directInvoiceInfo_1.InvoiceFeeInclVat, fromParts(0, 0, 0, false, 0))) ? singleton_2(invoiceFeeHtml) : empty_1(), delay(() => ((compare(totalAmountInclVatState[0], directInvoiceInfo_1.MinimumInvoiceAmountInclVat) < 0) ? singleton_2(warningMessage) : empty_1())))))))))))))))))));
            bodyHtml = react.createElement("div", {
                className: "invoices__direct-invoice",
                id: "create-direct-invoice-modal",
            }, ...children_42);
        }
    }
    return render_2(true, new ModalSize(1), getTranslation("Billing.DirectInvoice"), bodyHtml, getTranslation("Common.Cancel"), getTranslation("Billing.DirectInvoice.CreateInvoice"), (_arg_3) => {
        props.CloseModalFn();
    }, (_arg_4) => {
        let _arg_2;
        const isCreditInvoice = compare(totalAmountInclVatState[0], fromParts(0, 0, 0, false, 0)) < 0;
        const directInvoiceFees = filter((f_9) => f_9.IsChecked, feeState[0]);
        const batchType_1 = isCreditInvoice ? 3 : (props.EnableTerminationProcess ? (exists((f_10) => {
            const description = f_10.Description.toLowerCase();
            if (((description.indexOf("bruddgebyr") >= 0) ? true : (description.indexOf("slutfaktura") >= 0)) ? true : (description.indexOf("loppulasku") >= 0)) {
                return true;
            }
            else {
                return description.indexOf("final invoice") >= 0;
            }
        }, directInvoiceFees) ? 4 : 2) : 2);
        const directDebitDistributed = directDebitDistributedState[0];
        const campaignCode_1 = campaignCodeState[0];
        props.CreateDirectInvoice(new CreateDirectInvoiceDTO(true, noInvoiceFeeState[0], (_arg_2 = campaignCode_1, (_arg_2 === "") ? (void 0) : _arg_2), directDebitDistributed, batchType_1, isCreditInvoice, map_1((f_8) => (new InvoiceFeeDTO(f_8.FeeNr, f_8.Description, f_8.PeriodFrom, f_8.PeriodTo, f_8.ContractNr)), directInvoiceFees)));
        props.CloseModalFn();
    });
}, void 0, uncurry(2, void 0), void 0, "renderDirectInvoiceModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Invoices\\DirectInvoice.fs", 424);

export class RemoveDirectInvoiceProps extends Record {
    constructor(CloseModalFn, RemoveDirectInvoice) {
        super();
        this.CloseModalFn = CloseModalFn;
        this.RemoveDirectInvoice = RemoveDirectInvoice;
    }
}

export function RemoveDirectInvoiceProps$reflection() {
    return record_type("Containers.Invoices.DirectInvoice.RemoveDirectInvoiceProps", [], RemoveDirectInvoiceProps, () => [["CloseModalFn", lambda_type(unit_type, unit_type)], ["RemoveDirectInvoice", lambda_type(unit_type, unit_type)]]);
}

export const renderRemoveDirectInvoiceModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_4, children_2, children;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    let bodyHtml;
    const children_6 = [(children_4 = [(children_2 = [(children = [getTranslation("Billing.DirectInvoice.Remove.Information")], react.createElement("p", {
        className: "mt-2",
    }, ...children))], react.createElement("div", {}, ...children_2))], react.createElement("div", {
        className: "d-flex flex-column",
    }, ...children_4))];
    bodyHtml = react.createElement("div", {
        className: "d-flex flex-column color-black",
        id: "remove-direct-Invoice-modal",
    }, ...children_6);
    return render_2(true, new ModalSize(1), getTranslation("Billing.DirectInvoice.Remove"), bodyHtml, getTranslation("Common.No"), getTranslation("Common.Yes"), (_arg) => {
        props.CloseModalFn();
    }, (_arg_1) => {
        props.RemoveDirectInvoice();
        props.CloseModalFn();
    });
}, void 0, uncurry(2, void 0), void 0, "renderRemoveDirectInvoiceModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Invoices\\DirectInvoice.fs", 456);

